import axios from "axios";
import { useMemo, useState } from "react";

const getNFTMarketCap = async () => {
    try {
        const { data } = await axios.get(
            process.env.REACT_APP_API_URL + "/marketOverview/totalNFTMarketCap?type=full"
        )
        return data;
    }
    catch (error) {
        return error;
    }
}

export function useNFTMarketCap() {
    const [api, setAPIData] = useState<any>({
        loading: true,
        error: false,
        data: undefined
    });



    useMemo(async () => {
        const data = await getNFTMarketCap();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
